import { ContentHitComponent } from "./components/hitComponent/contentHit.component";
import { Base } from "./contentResultList.base";

export const ContentResultList = Object.assign(Base, {
    HitComponent: ContentHitComponent
});
